/**
 * Reine Regeln der Pruefung „geltende Fassungen" nach dem Speichern der
 * Grundlagen (Plan Stufe 6.1). `PlanungModul` startet sie NACH dem
 * Speichervorgang und wartet nicht darauf: haengt das Netz, bleiben
 * Aktionssperre, Erfolgsmeldung und „Speichern und drucken" sonst mit
 * haengen (Codex-Review 17.10.2026). Ein Ergebnis, das spaet eintrifft, darf
 * nur dann etwas setzen, wenn es noch zum angezeigten Projekt und zum
 * juengsten Lauf gehoert — und die Komponente noch da ist.
 */

/** Was ein Lauf beim Start festhaelt. */
export interface PruefungsLauf {
    /** Fortlaufende Nummer; jeder neue Start zaehlt hoch. */
    generation: number;
    /** Das Projekt, fuer das gelesen wurde. */
    projectId: string;
}

/** Was beim Eintreffen des Ergebnisses gilt. */
export interface PruefungsLage {
    /** Die Nummer des JUENGSTEN Starts. */
    generation: number;
    /** Das gerade angezeigte Projekt. */
    projectId: string;
    /** `false`, sobald die Komponente abgebaut ist. */
    eingehaengt: boolean;
}

/**
 * Darf das Ergebnis eines Laufs noch gesetzt werden? Nein nach Unmount, nach
 * einem Projektwechsel und wenn inzwischen ein neuerer Lauf gestartet wurde
 * (der aeltere wuerde sonst dessen Ergebnis ueberschreiben).
 */
export const pruefungGiltNoch = (lauf: PruefungsLauf, lage: PruefungsLage): boolean =>
    lage.eingehaengt && lauf.generation === lage.generation && lauf.projectId === lage.projectId;

/** Der Satz, wenn die Pruefung nicht laufen konnte — nie als „nichts veraltet" gedeutet. */
export const fassungsPruefungFehlerText = (lesefehler: string): string =>
    'Ob freigegebene oder versendete Unterlagen von der Änderung betroffen sind, konnte nicht geprüft werden: '
    + `${lesefehler.trim()} Der Reiter „Übergabe" zeigt den Stand, sobald er lesbar ist.`;

/**
 * Nach dem Speichern meldet sich die Pruefung als LEISTE, nicht als Dialog:
 * die Grundlagen speichern sich automatisch, ein Dialog kaeme sonst mitten
 * im Tippen. „Später" gilt fuer genau diese Abweichung (Unterlage + Hash) in
 * dieser Sitzung — eine weitere Aenderung ergibt einen neuen Hash, dann
 * meldet sich die Leiste wieder.
 */
export const fassungsHinweisSchluessel = (s: { unterlage: string; hash: string }): string => `${s.unterlage}:${s.hash}`;

/** Satz der Leiste. */
export const fassungsHinweisText = (anzahl: number): string => (anzahl === 1
    ? 'Die Grundlagen weichen jetzt von einer freigegebenen oder versendeten Unterlage ab. Neue Fassung anlegen oder bewusst beibehalten?'
    : `Die Grundlagen weichen jetzt von ${anzahl} freigegebenen oder versendeten Unterlagen ab. Neue Fassung anlegen oder bewusst beibehalten?`);
